import {ShaderMaterial} from "three";
import exposureCalculationVertex
    from "features/apartmentViewer/ApartmentViewer/shaders/exposureCalculationMaterial/exposureCalculationVertex.glsl";
import exposureCalculationFragment
    from "features/apartmentViewer/ApartmentViewer/shaders/exposureCalculationMaterial/exposureCalculationFragment.glsl";

export class ExposureCalculationMaterialFactory {
    public static createMaterial() : ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                u_image: { value: null },
                u_fovy_scale: { value: 1 },
            },
            vertexShader: exposureCalculationVertex,
            fragmentShader: exposureCalculationFragment,
        })
    }
}
